module.exports = __webpack_public_path__ + "static/media/gridBlue.57e5550b.svg";